import { EPDS_FORM_TITLE } from "../constants";

/**
 * test if the form is EPDS
 * Note: this is a short-term workaround, should improve the criteria in the future
 */
export default function isEPDSForm(title?: string) {
  return title === EPDS_FORM_TITLE;
}
